import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IcoCicle, Select } from '../../../components'
import { putFiltersProvisorio } from '../redux/benchmarkActions'

export default () => {
  const dispatch = useDispatch()
  const { ciclos, sistema } = useSelector(state => state.layoutState)
  const { filtersProvisorio: { ciclo } } = useSelector(state => state.benchmarkState)

  const [ciclos1, setCiclos1] = useState([])
  const nls = require(`../nls/${sistema.idioma}.json`)

  useEffect(() => {
    init()
  }, [ciclos, sistema.idioma])

  const init = () => {
    const data = ciclo?.anoMesCiclo?.split('-')

    if (data) {
      const mes = nls.nomesMeses.find(nm => Number(nm.id) === Number(data[1]))

      const ciclo1Result = {
        ...ciclo,
        mesAno: `${mes?.name}-${data[0]}`,
        anoMes: `${data[0]}-${data[1]}`,
        ano: data[0],
        mes: data[1]
      }

      dispatch(putFiltersProvisorio({ name: 'ciclo', value: ciclo1Result }))
    }

    const ciclos1Result = ciclos.map(ciclolido => {
      const data = ciclolido.anoMesCiclo.split('-')
      const mes = nls.nomesMeses.find(nm => Number(nm.id) === Number(data[1]))

      return {
        ...ciclolido,
        mesAno: `${mes?.name}-${data[0]}`,
        anoMes: `${data[0]}-${data[1]}`,
        ano: data[0],
        mes: data[1]
      }
    })

    setCiclos1(ciclos1Result)
  }

  const handleFormFilter = (e) => {
    dispatch(putFiltersProvisorio(e))
  }

  return (
    <div className='box-benchmark-search benchmark-search-ciclo'>
          <Select
      name='ciclo'
      cy='filter-cycle'
      label={nls.ciclo}
        options={ciclos1}
        selected={ciclo}
        action={(e) => handleFormFilter(e)}
        selectedItem={false}
        labelCustom={(e) => <><IcoCicle /> {e.cicloPorExtenso}</>}
        optionLabel='cicloPorExtenso'
        optionValue='anoMes'
      />
    </div>
  )
}